import type { ReactNode } from 'react';

export enum VIEW_CHECKOUT_CONST {
  TEST_ID = 'view-checkout',
}

export type CheckoutViewProps = {
  children: ReactNode;
  testid: string;
};
